import { Component } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';

import { AnaliseService } from '../../../../../providers/analise-service';
import { AlertService } from '../../../../../providers/alert-service';
import { MenuService } from '../../../../../providers/menu-service';

import { ModulosController } from '../../../modulos-controller';

import { UsuarioService } from '../../../../../providers/usuario-service';
import { GestaoPcaService } from '../../../../../providers/gestao-pca-service';

@Component({
  selector: 'page-balanco-dfc',
  templateUrl: 'balanco-dfc.html',
  providers: [
    AnaliseService
  ]
})

export class ValidacaoConsistenciaBalancoDFCPage extends ModulosController {
  listaDados: any = [];
  loading: boolean = true;
  submetendoNoCertificado: boolean = false;
  idSecaoPagina: string = "1134";
  abaTipoBalanco: any = '';
  erro: any = '';

  constructor(public navCtrl: NavController,
    public alertService: AlertService,
    public navParams: NavParams,
    public analiseService: AnaliseService,
    public usuarioService: UsuarioService,
    public gestaoPcaService: GestaoPcaService,
    public modalCtrl: ModalController,
    private menuService: MenuService) {
    super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);

    this.abaTipoBalanco = 'ativo';

    this.carregarDados();
    this.setModuloId(4);
    this.setIdModuloPca(this.navParams.get('analise').idModuloPca);
  }

  carregarDados() {
    this.analiseService.obterAnaliseExercicioFluxoDeCaixa(this.idSecaoPagina).subscribe(data => {
      this.listaDados = data;
      this.loading = false;
    }, error => {
      console.log("erro: " + error);
      this.erro = error.mensagem;
      this.loading = false;
    });
  }

  mostrarInconsistencia(inconsistente: boolean, dsConta: any, dsGrupo: any) {
    if (inconsistente) {
      this.alertService.mostraAlerta("", "O valor contabilizado na conta genérica <strong>" +
        dsConta + "</strong>, pertencente ao grupo <strong>" + dsGrupo +
        "</strong>, ultrapassa o limite aceitável de 10%, definido na norma NBCT 16.6.");
    }
  }

  formatarPorcentagem(valor) {
    return valor.toString().replace('.', ',') + "%";
  }

  formatarValorNumerico(valor) {
    let valorFormatado = new Intl.NumberFormat('pt-BR',
      {
        style: 'currency',
        currency: 'BRL'
      }).format(valor);

    return valorFormatado.substr(2, valorFormatado.length).replace('$', '-');
  }

  voltarParaContabilidade() {
    this.menuService.redirecionarPagina(this.analiseService.obterIdPaginaContabilidade());
  }

  salvarFlagIncluir() {
    let idAnalise = "";

    if (this.listaDados) {

      this.loading = true;

      idAnalise = this.listaDados.idAnalise;
      this.listaDados.resultadoAnalise = this.capitalize(this.listaDados.resultadoAnalise);
      this.analiseService.salvarAnaliseVCEEDFC(this.listaDados).subscribe(data => {
        this.alertService.mostraAlerta("", "Salvo com sucesso.");
        this.loading = false;
      }, error => {
        this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar:" + error);
        this.loading = false;
      });
    }
  }

  submeterNoCertificado() {
    this.loading = true;

    let idAnalise = "";

    if (this.listaDados.resultadoAnalise == undefined || !this.listaDados.resultadoAnalise || this.listaDados.resultadoAnalise.replace(/^\s+|\s+$/g, '') == "" || this.listaDados.resultadoAnalise == null) {
      this.alertService.mostraAlerta("", "O Parecer do Analista é obrigatório.");
      this.loading = false;
    } else {
      if (this.listaDados) {
        idAnalise = this.listaDados.idAnalise;
        this.listaDados.resultadoAnalise = this.capitalize(this.listaDados.resultadoAnalise);
        this.analiseService.submeterAnaliseVCEEDFC(this.listaDados).subscribe(data => {
          this.alertService.mostraAlerta("", "Submetido com sucesso.");
          this.voltarParaContabilidade();
        }, error => {
          this.alertService.mostraAlerta("", "Ocorreu um erro ao submeter:" + error);
          this.loading = false;
        });
      }
    }
  }

  capitalize(str) {
    let retorno = "";

    if (str) {
      retorno = str.charAt(0).toUpperCase() + str.slice(1);
    }

    return retorno;
  }
}




// WEBPACK FOOTER //
// ./src/pages/modulos/modulo-analise/validacao-consistencia/balanco-dfc/balanco-dfc.ts